"use strict";

class StationSettingsApiRestOveviewCtrl {

    constructor($rootScope, $http, $scope, $mdToast, $mdDialog, $state) {
        this.$rootScope = $rootScope;

        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.tokens = {};
        this.fetch();
        this.currentToken = null;
        this.genToken = {};

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);
    }


    fetch() {
        this.$http.get('/tokens').then(response => {

            this.tokens = response.data;

        });
    }


    checkActivefield(index) {

        if (this.$state.params.tokenId == index) {
            this.currentToken = this.tokens[index];
            return true;
        } else {
            return false;
        }
    }


    openToken(index) {
        this.$state.go('stationsettings.api.rest.token', {tokenId: index});
    }


    addToken() {
        this.$http.post('/tokens/generate')
            .then((response) => {

                let token = response.data;
                token.permissions = [];

                let index = this.tokens.push(token);

                this.openToken(index - 1);
            });
    }


    save() {
        const {
            genToken,
            currentToken,
            $http,
            $mdToast,
        } = this;

        genToken.title = currentToken.title;
        genToken.version = parseInt(currentToken.version);

        $http.put('/tokens/' + genToken.id, genToken).then((response) => {

            let refactoredPermissions = [];
            for (let id in genToken.permissions) {
                if (genToken.permissions.hasOwnProperty(id)) {
                    if (genToken.permissions[id] === true) {
                        refactoredPermissions.push({id});
                    }
                }
            }

            currentToken.secret = null;
            currentToken.permissions = refactoredPermissions;

            $mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=Rest_credentials',
                hideDelay: 6000,
                position: ('top right')
            });
        });
    }


    apiKeyDelete(id, $index, ev) {

        ev.stopPropagation();

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true
        }).then(() => {

            this.$http.delete('/tokens/' + id).then(() => {

                this.tokens.splice($index, 1);
            });
        });
    }


    createOrUpdateApiKey(tokenIndex, tokenId) {

        this.$mdDialog.show({
            controller: 'ApiDialogCtrl',
            templateUrl: 'apiKeyDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
            locals: {

                tokenId: tokenId,
                tokenIndex: tokenIndex,
                tokens: this.tokens
            }
        }).then(function () {

        }, (remove) => {

            if (remove != null) {

                this.$http.delete('/tokens/' + remove);
            }

        });
    }
}

StationSettingsApiRestOveviewCtrl.$inject = [
    '$rootScope',
    '$http',
    '$scope',
    '$mdToast',
    '$mdDialog',
    '$state'
];

module.exports = StationSettingsApiRestOveviewCtrl;